import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <AboutSection />
        <IndexSection />
        <CardsSection />
        <AppSection />
        <TopicsSection />
        <FeaturesSection />
        <MediaSection />
        <FaqSection />
        <UpdatesSection />
        <ContactSection />
        <CarouselSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}